export enum Color {
  red = 'red',
  pink = 'pink',
  purple = 'purple',
  deeppurple = 'deep-purple',
  indigo = 'indigo',
  blue = 'blue',
  lightblue = 'light-blue',
  cyan = 'cyan',
  teal = 'teal',
  green = 'green',
  lightgreen = 'light-green',
  lime = 'lime',
  yellow = 'yellow',
  amber = 'amber',
  orange = 'orange',
  deeporange = 'deep-orange',
  brown = 'brown',
  grey = 'grey',
  bluegrey = 'blue-grey',
}
export interface TasksListResult {
  taskLists: {
    globalId: string;
    title: string;
  }[];
  tasks: {
    globalId: string;
    taskListId: string;
    done: boolean;
    title: string;
    deadlineDate?: number | null;
  }[];
  labels: {
    taskId: string;
    labelId: string;
  }[];
  workspaceLabels: {
    globalId: string;
    title: string;
    color: Color;
  }[];
  assignees: {
    taskId: string;
    userId: number;
  }[];
  users: {
    id: number;
    firstname: string;
  }[];
  avatars: {
    userId: number;
    storedFileUUID: string;
  }[];
}
interface Assignee {
  displayName: string;
  avatarUrl: string;
}
interface Label {
  title: string;
  color: Color;
}
interface Task {
  done: boolean;
  title: string;
  deadlineDate?: number | null;
  assignees: Assignee[];
  labels: Label[];
}

export interface TaskListReadOnly {
  title: string | undefined;
  tasks: Task[];
}

export interface AllowActions {
  boardCreate?: boolean;
  boardUpdate?: boolean;
  boardDelete?: boolean;
  taskListCreate?: boolean;
  taskListUpdate?: boolean;
  taskListDelete?: boolean;
  taskListConvertToBoard?: boolean;
  taskListNoteNavigate?: boolean;
  taskListNoteUpdate?: boolean;
  taskCreate?: boolean;
  taskUpdate?: boolean;
  taskDelete?: boolean;
  taskDuplicate?: boolean;
  taskCopy?: boolean;
  taskCopyLink?: boolean;
  taskConvertToTaskList?: boolean;
  taskDragNDrop?: boolean;
  taskListDragNDrop?: boolean;
  taskStatusChange?: boolean;
  taskLabelAdd?: boolean;
  taskLabelDelete?: boolean;
  workspaceLabelCreate?: boolean;
  workspaceLabelUpdate?: boolean;
  workspaceLabelDelete?: boolean;
  taskAssigneeCreate?: boolean;
  taskAssigneeDelete?: boolean;
  taskReminderCreate?: boolean;
  taskReminderDelete?: boolean;
  taskCommentAdd?: boolean;
  taskDescriptionEdit?: boolean;
  taskAttachmentAdd?: boolean;
  taskAttachmentDelete?: boolean;
  membersInvite?: boolean;
}

export interface SetupTasksParams {
  workspaceId: string;
  orgId: string;
  userId: number;
  shareId: string;
  securityKey: string;
  noteId: string;
  sessionId: string;
  gatewayUrl: string;
  staticAssetPrefix: string;
  userRole: string;
}

export enum TASKS_ANALYTICS_LABEL {
  TaskList = 'tasks_view_list',
  TaskDetailed = 'tasks_view_detailed',
  TaskBoard = 'tasks_view_board',
  TaskDashboard = 'tasks_view_panel',
}

export enum TASK_EVENT_FEATURE_TYPE {
  DASHBOARD = 'dashboard',
  TASK_LIST = 'task-list',
  TASK_BOARD = 'task-board',
  TASK_DETAILED = 'task-detailed',
}

export enum TASK_EVENT_ACTIONS {
  TASK_LIST_COMPLETE_ALL = 'task-list-complete-all',
  TASK_LIST_UNCOMPLETE_ALL = 'task-list-uncomplete-all',
  INVITE_MEMBERS = 'invite-members',
  ASSIGNEE_LIMIT = 'assignee-limit',
  REMINDER_LIMIT = 'reminder-limit',
  DATE_LIMIT = 'date-limit',
  TASK_LIST_DELETE = 'task-list-delete',
  TASK_LIST_CONVERT_TO_BOARD = 'task-list-convert-to-board',
  TASK_COPY_LINK = 'task-copy-link',
  TASK_DUPLICATED = 'task-duplicated',
  DESCRIPTION_PREMIUM_LIMIT = 'description-premium-limit',
  COMMENTS_PREMIUM_LIMIT = 'comments-premium-limit',
  ATTACHMENTS_PREMIUM_LIMIT = 'attachments-premium-limit',
  ESTIMATE_PREMIUM_LIMIT = 'task-estimate-premium-limit',
  TIME_PREMIUM_LIMIT = 'task-time-premium-limit',
  COLUMN_CONVERTED_TO_TASK_LIST = 'column-converted-to-task-list',
  NOTE_NAVIGATE = 'note-navigate',
  TASK_NOT_FOUND = 'task-not-found',
  WORKSPACE_LABEL_UNIQUE_TITLE_ERROR = 'workspace-label-unique-title-error',
  TASK_DROP_DISABLED = 'task-drop-disabled',
  DASHBOARD_NAVIGATE = 'dashboard_navigate',
}
